import angular from 'angular';

(() => {
  const HttpInterceptor = function (
    $rootScope,
    $q,
    localStorageService,
    Logger,
    ENV,
    API_URL,
    CMS_API_URL,
    serverless_tracking_api_url,
    serverless_api_url,
    CLOUDFLARE_ACCESS_CLIENT_ID,
    CLOUDFLARE_ACCESS_CLIENT_SECRET,
  ) {
    'ngInject';
    /*
      All http requests will run through our custom interceptors.
      It is a promise based chain where we return the argument to the next call
      in loop.
      Function names are particular and cannot be changed
    */
    const BODACDC_625 = FEATURE_BODACDC_625;
    const BODACDC_1029 = FEATURE_BODACDC_1029;

    /**
     * Gives us access to the http request before being sent up to the server
     * @name request
     * @memberof Interceptor
     * @param {Object} config  Object
     * @returns {Object} Configuration Object
     */

    const request = function (config) {
      const token = window.localStorage.getItem('token') || '';
      // console.log("config");
      // console.log(config);
      // Only append these headers if we are accessing our own resources
      // if(config.url === "https://hooks.slack.com/services/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"){
      if (config.url.indexOf('hooks.slack.com/services') >= 0) {
        config.headers.Accept = 'application/json';
        config.headers['Content-Type'] = undefined;
      }

      //Add withCredentials to POST PUT or DELETE for Set-Cookie
      const requireCredentialsRequest = ['POST', 'PUT', 'DELETE'];
      if (BODACDC_625 && requireCredentialsRequest.includes(config.method.toUpperCase())) {
        config.withCredentials = true;
      }

      if (config.url.indexOf(API_URL) >= 0) {
        if (config.url.indexOf('/v2.0/admin/') > 0 && config.url.indexOf(':2053/v2.0/admin/') < 0)
          config.url = config.url.replace('/v2.0/admin/', ':2053/v2.0/admin/'); // if (config.url.indexOf('polling') < 0) {
        //   Logger.debug(`${config.method} ${config.url}`);
        // }

        /*
          We use Cloudflare access to protect sensitive API Endpoints
          https://developers.cloudflare.com/cloudflare-one/identity/service-auth/service-tokens
            - Provide the Cloudflare Access Token headers
              CF-Access-Client-Id & CF-Access-Client-Secret
         */
        // if (config.url.indexOf('v2.0/admin') > 0 || config.url.indexOf('v2.0/super') > 0 || config.url.indexOf('v2.0/system') > 0) {
        //   config.headers['CF-Access-Client-Id'] = CLOUDFLARE_ACCESS_CLIENT_ID;
        //   config.headers['CF-Access-Client-Secret'] = CLOUDFLARE_ACCESS_CLIENT_SECRET;
        // }

        if (config.data && !config.data.file) {
          config.headers.Accept = 'application/json';
          config.headers['Content-Type'] = 'application/json';
        }

        config.headers.Authorization = BODACDC_1029 ? token : window.localStorage.getItem('token');
      }

      if (config.url.indexOf(CMS_API_URL) >= 0) {
        // config.headers.Accept = 'application/json';
        // config.headers['Content-Type'] = 'application/json';
        config.headers.Authorization = BODACDC_1029 ? token : window.localStorage.getItem('token');

        if (config.data && !config.data.file) {
          config.headers.Accept = 'application/json';
          config.headers['Content-Type'] = 'application/json';
        }
      }

      if (config.url.indexOf(serverless_api_url) >= 0) {
        // config.headers.Accept = 'application/json';
        // config.headers['Content-Type'] = 'application/json';
        config.headers.Authorization = BODACDC_1029 ? token : window.localStorage.getItem('token');

        if (config.data && !config.data.file) {
          config.headers.Accept = 'application/json';
          config.headers['Content-Type'] = 'application/json';
        }
      } // if (config.url.indexOf(`${serverless_tracking_api_url }tracking`) >= 0) {

      if (config.url.indexOf(serverless_tracking_api_url + 'tracking') >= 0) {
        // config.headers.Accept = 'application/json';
        // config.headers['Content-Type'] = 'application/json';
        config.headers.Authorization = BODACDC_1029 ? token : window.localStorage.getItem('token');

        if (config.data && !config.data.file) {
          config.headers.Accept = 'application/json';
          config.headers['Content-Type'] = 'application/json';
        }
      }

      return config;
    };
    /**
     * Receives an error if request is inproper
     * @name requestError
     * @memberof Interceptor
     * @param {Object} err Object
     * @returns {Object} Error Object
     */

    const requestError = function (err) {
      return err;
    };
    /**
     * Access to response payload before being sent to our listeners
     * @name response
     * @memberof Interceptor
     * @param {Object} res Object
     * @returns {Object} Response Object
     */

    const response = function (res) {
      return res;
    };
    /**
     * Receives an error if request is inproper
     * @name requestError
     * @memberof Interceptor
     * @param {Object} err Object
     * @emits {Number} Error Status
     * @returns {Object} Rejected Promise
     */

    const responseError = function (err) {
      /*
       * Broadcast events throughout angular system if we need to pick up on
       */
      switch (err.status) {
        case 0:
          $rootScope.$broadcast('event:internet-disconnected');
          break;

        case 401:
          $rootScope.$broadcast('unauthorized');
          break;
      }
      /* This will force response into our error block */

      return $q.reject(err);
    };

    return {
      response,
      responseError,
      request,
      requestError,
    };
  };

  HttpInterceptor.$inject = [
    '$rootScope',
    '$q',
    'localStorageService',
    'Logger',
    'ENV',
    'API_URL',
    'CMS_API_URL',
    'serverless_tracking_api_url',
    'serverless_api_url',
    'CLOUDFLARE_ACCESS_CLIENT_ID',
    'CLOUDFLARE_ACCESS_CLIENT_SECRET',
  ];
  angular.module('pims').service('HttpInterceptor', HttpInterceptor);
})();
